import emailIcon from "../assets/email_icon.png";
import linkedinIcon from "../assets/linkedin_icon.png";
// import resume from "../assets/shukert_resume.pdf";
// import resumeIcon from "../assets/paper-icon.png";

const SOCIAL_PROFILES = [
    {
        id: 1,
        link: 'mailto:abe@elecba.com',
        image: emailIcon
    },
    {
        id: 2,
        link: 'https://www.linkedin.com/in/abe-shukert-13a04a53/',
        image: linkedinIcon
    }
    // {
    //     id: 3,
    //     link: resume,
    //     image: resumeIcon
    // }
];

export default SOCIAL_PROFILES;